import { useMemo } from "react";

import { buildSettlementReportHtmlDocument, openPdfPrintWindow } from "../helper/pdf";

export default function useSettlementPdfExport(documentData) {
  const isDownloadReady = useMemo(() => {
    return Boolean(
      documentData?.caseDetail &&
        documentData?.hasExportableContent &&
        !documentData?.isDocumentLoading
    );
  }, [documentData]);

  const handleDownloadPdf = async (selectedSections) => {
    if (!isDownloadReady) {
      return;
    }

    const htmlContent = await buildSettlementReportHtmlDocument(documentData, selectedSections);
    const title =
      documentData?.caseDetail?.name ||
      documentData?.headerFields?.find((field) => field.label === "Case Name")?.value ||
      "Settlement Statement";

    await openPdfPrintWindow(htmlContent, title);
  };

  return {
    handleDownloadPdf,
    isDownloadReady,
  };
}
